// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1z2eP","left":"InfoRow_left__gQFEu"};